import { cn } from "#lib/utils";

// One spinner exists in the product; everything else loads as a skeleton.
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("animate-pulse-soft rounded-full bg-skeleton", className)}
      {...props}
    />
  );
}

export { Skeleton };
